<template lang="html">
   <div class="upload-alert">
      <div class="back-progress" :style="{width: `${progress}%`}">
         <div class="line"></div>
      </div>
      <div class="clearfix top-content">
         <div class="left">
            <div class="name">{{name}}</div>
            <div class="current-status">{{current}}/{{total}}</div>
         </div>
         <div class="right">
            <div class="btns">
               <div class="fa fa-times"></div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   export default {
      props: {
         progress: {
            default: 0
         },
         current: {
            default: '0 Bytes'
         },
         total: {
            default: '1.2Mb'
         },
         name: {
            default: 'Default File.png'
         }
      }
   }
</script>

<style lang="scss">
$notification-progress-color: #ededed;

   .upload-alert{
      float: left;
      width: 250px;
      height: 70px;
      background: $white;
      border-radius: 4px;
      border: dashed 1px $border-grey;
      position: relative;
      margin: 0 5px;

      .back-progress{
         background: $notification-progress-color;
         position: absolute;
         top: 0;
         bottom: 0;
         left: 0;
         right: 0;
         border-bottom: solid 2px $primary;
      }
      .top-content{
         position: absolute;
         top: 0;
         bottom: 0;
         left: 0;
         right: 0;
         padding: 15px 10px;
      }
      .left{
         float: left;

         .name{
            font-size: 13px;
            font-weight: 600;
         }
         .current-status{
            font-size: 11px;
            font-weight: 600;
            margin: 1px 0 0 0;
         }
      }
      .right{
         float: right;

         .btns{
            padding: 8px 7px 5px 0;
            font-size: 18px;
            width: 100%;

            .fa{
               cursor: pointer;
            }
            .fa:hover{
               font-size: 19px;
               color: #000;
            }
         }
      }
   }
</style>